/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
const appShell = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

if (rootElement.hasChildNodes()) {
  // Hydrating pre-rendered react-snap content — StrictMode is excluded
  // here because it causes false hydration mismatch warnings in React 18.
  ReactDOM.hydrateRoot(rootElement, appShell, {
    onRecoverableError: (error) => {
      // Suppress React hydration mismatch warnings (#418, #423) caused by
      // react-snap pre-rendering. React recovers automatically by switching
      // to client rendering — these errors are non-fatal and expected with
      // static pre-rendering. Only suppress hydration-related errors.
      const msg = error?.message || '';
      if (
        msg.includes('Hydration') ||
        msg.includes('hydrat') ||
        msg.includes('did not match') ||
        msg.includes('server') ||
        error?.digest?.includes('418') ||
        error?.digest?.includes('423')
      ) {
        return;
      }
      console.error('[React]', error);
    },
  });
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>{appShell}</React.StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
